import { Injectable, signal } from '@angular/core';

export interface Toast { id: number; type: 'success' | 'danger' | 'warning'; message: string; }

@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly toasts = signal<Toast[]>([]);

  success(message: string) { this.add('success', message); }
  danger (message: string) { this.add('danger',  message); }
  warning(message: string) { this.add('warning', message); }

  dismiss(id: number) { this.toasts.update(t => t.filter(x => x.id !== id)); }

  private add(type: Toast['type'], message: string) {
    const id = Date.now();
    this.toasts.update(t => [...t, { id, type, message }]);
    setTimeout(() => this.dismiss(id), 4500);
  }
}
